import React, { useContext } from 'react';
import { LangContext } from '../App';
import { translations } from '../lib/translations';

const FULL_LOGO_URL =
  'https://customer-assets.emergentagent.com/job_bbc14d05-1309-4872-bdcf-991a413c9c8e/artifacts/fm7rr61v_JCS_sem_moradas_transparente.png';

export default function Footer() {
  const lang = useContext(LangContext);
  const t = translations[lang].footer;

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer
      className="bg-[#111111] py-16 px-6"
      data-testid="footer-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col items-center gap-8">
          {/* Logo */}
          <button
            onClick={() => scrollTo('home')}
            className="opacity-70 hover:opacity-100 transition-opacity duration-300"
            data-testid="footer-logo-btn"
            aria-label="Voltar ao início"
          >
            <img
              src={FULL_LOGO_URL}
              alt="Jéssica Costa da Silva — Advogada"
              className="h-20 w-auto"
              style={{ filter: 'brightness(0) invert(1) sepia(1) saturate(0) hue-rotate(0deg) opacity(0.6)' }}
              data-testid="footer-logo"
            />
          </button>

          {/* Divider */}
          <div className="w-12 h-px bg-[#6B2D3E]" />

          {/* Address */}
          <p className="font-sans text-xs text-[#666666] text-center tracking-wide">
            {t.address}
          </p>

          {/* Copyright */}
          <p className="font-sans text-xs text-[#444444] tracking-widest uppercase text-center">
            © {new Date().getFullYear()} Jéssica Costa da Silva — {t.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}
